import { render, staticRenderFns } from "./feedbackDialog.vue?vue&type=template&id=4e25964d&scoped=true&"
import script from "./feedbackDialog.vue?vue&type=script&lang=ts&"
export * from "./feedbackDialog.vue?vue&type=script&lang=ts&"
import style0 from "./feedbackDialog.vue?vue&type=style&index=0&id=4e25964d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e25964d",
  null
  
)

export default component.exports